import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteProductCategory($companyId: ID!, $id: ID!) {
    deleteProductCategory(companyId: $companyId, id: $id) {
      productCategory {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
